import React, { Fragment, useContext, useState, useEffect } from 'react';
import { map, find } from 'lodash';
import { FocusBaseContext, MarkupContext } from '../../../contexts';
import Dropdown from '../../../../../common/dropdown';
import { conceptDropdownStyles } from '../../../../../common/dropdown/styles';
import { changeConceptRequest, updateRegionRequest } from '../../../requests';
import { stringifyFilterData } from "../../../../../../express/researcher/common/helpers";
import Reaction from './reaction';
import MarkupOption from './markupOption';

const FiltersRow = () => {
  const {
    currentSummary, selectedConceptId, markupTool, setHeatmap,
    findRegionId,
    currentKinds, findCurrentKinds, updateCurrentKinds, markupType, updateMarkupType, findMarkupType,
    saveUserSettings, onMarkupSettingsChange, conceptById, selectedRegionId, setRegions, findSelectedRegion
  } = useContext(FocusBaseContext);
  const {
    setLoading, allowedReactions, allowedTools, setChangeConceptStage, currentFilters
  } = useContext(MarkupContext);
  const getMarkupConcepts = () => map(
    currentSummary.report.concepts,
    (el) => ({ value: el.id, label: el.name })
  );
  const [ conceptsList, setConceptsList ] = useState(getMarkupConcepts);
  const [ conceptError, setConceptError ] = useState(null);
  useEffect(() => {
    setConceptsList(getMarkupConcepts());
  }, [ currentSummary ]);
  const defaultValue = find(conceptsList, (el) => (el.value === selectedConceptId()));
  const selectedRegion = findSelectedRegion(markupTool.regions, selectedRegionId);

  const handleChangeConcept = (selectedItem) => {
    setChangeConceptStage('start');
    setLoading(true);
    setConceptError(false);
    currentSummary.selected_concept_id = selectedItem.value;
    const params = { concept_id: selectedItem.value };
    if (currentSummary.filter) {
      params.filter = currentSummary.filter;
    }

    changeConceptRequest(currentSummary.heatmap_path, params, (response) => {
      const newHeatmap = { ...response.data, ...{ changed: true } };
      setHeatmap(newHeatmap);
      markupTool.deselectComments();
      const selectedId = findRegionId(currentSummary, newHeatmap);
      markupTool.setAllComments(
        newHeatmap.filtered_comments,
        selectedId,
        findCurrentKinds(currentSummary, newHeatmap),
        findMarkupType(currentSummary, newHeatmap),
        conceptById(selectedItem.value).regions
      );

      if (selectedRegion !== null) {
        const selectedRegion = findSelectedRegion(conceptById(selectedItem.value).regions, selectedId);
        updateRegionRequest(
          selectedRegion.update_path,
          {
            positive: markupTool.reactions.positive,
            negative: markupTool.reactions.negative,
            confusing: markupTool.reactions.confusing,
            filters: currentFilters(), filter_data: stringifyFilterData([ ...currentSummary.filter ])
          },
          (response) => {
            setRegions(response.data.regions);
          });
      }
      setRegions(markupTool.regions);
    }, (response) => {
      setConceptError(response.statusText ? response.statusText : 'Internet connection problem');
    },
    () => {
      setChangeConceptStage('received');
      setLoading(false);
    });
  };

  const handleChangeReaction = (newHash) => {
    const newValues = { ...currentKinds, ...newHash };
    if (selectedRegionId) {
      updateRegionRequest(selectedRegion.update_path, newValues,
        (response) => {
          setRegions(response.data.regions);
        });
    }
    markupTool.setReactions(newValues);
    saveUserSettings({ selected_reactions: newValues, concept_id: selectedConceptId() });
    updateCurrentKinds(newValues);
    onMarkupSettingsChange();
  };

  const handleChangeMarkup = (newValue, event) => {
    saveUserSettings({ markup_type: newValue, concept_id: selectedConceptId() });
    if (selectedRegionId) {
      updateRegionRequest(selectedRegion.update_path, { markup_type: newValue },
        (response) => {
          setRegions(response.data.regions);
        });
    }
    markupTool.setMarkupType(newValue);
    updateMarkupType(newValue);
    onMarkupSettingsChange();
  };

  const reactionsList = {
    positive: 'Positive',
    negative: 'Negative',
    confusing: 'Confusing'
  };

  return (
    <div className="summary-markup_filter">
      <div className="page-row form-group -lg">
        <div className="page-row_col">
          <div className="form-group">
            <div className="form-label">Concept shown:</div>
            <Dropdown
              className="concept-selector"
              value={ defaultValue }
              searchable
              options={ conceptsList }
              onChange={ handleChangeConcept }
              customStyles={ conceptDropdownStyles }
            />
            <div className="form-error">{ conceptError }</div>
          </div>
        </div>
        <div className="page-row_col">
          <div className="form-label" />
          <div className="form-switch-group-container">
            {
              map(reactionsList, (title, kind) => (
                <Fragment key={ kind }>
                  {
                    allowedReactions[kind] &&
                    <Reaction
                      title={ title }
                      kind={ kind  }
                      colors={ currentSummary.colors }
                      values={ currentKinds }
                      onChange={ handleChangeReaction }
                    />
                  }
                </Fragment>
              ))
            }
          </div>
        </div>
        <div className="page-row_col">
          <div className="form-label" />
          <div className="button-group -sm">
            {
              allowedTools.all ? (
                <>
                  <MarkupOption
                    title="All"
                    id="type_all"
                    name="markupType"
                    value="area_and_text"
                    valueCheck={ markupType }
                    onChange={ handleChangeMarkup }
                  />
                  <MarkupOption
                    title="Text"
                    id="type_text"
                    name="markupType"
                    value="text"
                    valueCheck={ markupType }
                    onChange={ handleChangeMarkup }
                  />
                  <MarkupOption
                    title="Image"
                    id="type_area"
                    name="markupType"
                    value="area"
                    valueCheck={ markupType }
                    onChange={ handleChangeMarkup }
                  />
                </>
              ) : (
                <>
                  {
                    allowedTools.text &&
                    <MarkupOption
                      title="Text Tool Only"
                      name="temp_markupType"
                      value="temp_text"
                      disabled
                    />
                  }
                  {
                    allowedTools.area &&
                    <MarkupOption
                      title="Image Tool Only"
                      name="temp_markupType"
                      value="temp_area"
                      disabled
                    />
                  }
                </>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltersRow;
